'use strict'

import lazySizes from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Swiper from 'swiper/bundle';
window.swiper = Swiper

import urlsafe from './helpers/urlsafe';
import loadjs from './helpers/loadjs';

document.addEventListener('alpine:init', () => {

	const textToSpeachElm = document.querySelector('.text-to-speech');

	Alpine.data('localHeadlineLinks', function () {
		return {
			links: [],
			init: function () {
				this.links = [];
				if (textToSpeachElm != null) {
					const headlines = textToSpeachElm?.querySelectorAll('h2')

					for (let headline of headlines) {
						let headlineText = headline.textContent
						let urlSafeHeadlineBase = urlsafe(headlineText)
						let urlSafeHeadline = urlSafeHeadlineBase
						let count = 0

						while (this.links.filter(link => link.href === urlSafeHeadline).length > 0) {
							count++;
							urlSafeHeadline += `-${count}`
						}

						headline.setAttribute('id', urlSafeHeadline)

						this.links.push({
							'href': `#${urlSafeHeadline}`,
							'title': headlineText
						});
					}
				}
			}
		}
	})

	Alpine.data('helpTools', function () {
		return {
			counter: 0,
			speakStatus: false,
			responsiveVoiceLoaded: false,
			init() {
				loadjs('https://code.responsivevoice.org/responsivevoice.js?key=ONk80qia', null, document.body)
				this.responsiveVoiceLoaded = true
			},
			speakPause() {
				this.speakStatus = "paused"
				responsiveVoice.pause()
			},
			speakResume() {
				this.speakStatus = "speaking"
				responsiveVoice.resume()
			},
			speakOut() {
				this.speakStatus = "speaking"
				if (responsiveVoice) {
					responsiveVoice.speak(textToSpeachElm.innerText, "Danish Female")
				}
				else {
					console.error("ResponsiveVoice not loaded")
				}
			},
			speakEnd() {
				let links = document.querySelectorAll('a');

				for (let link of links) {
					link.addEventListener('click', function () {
						this.speakStatus = "paused"
						responsiveVoice.pause()
					})
				}
			},
			decreaseFont() {
				let elements = textToSpeachElm.querySelectorAll('p, h2, h3, li, a');
				this.counter--

				let decreaseFont = document.querySelector('.decrease-font');
				let increaseFont = document.querySelector('.increase-font');

				if (this.counter >= 0) {
					increaseFont.classList.remove('opacity-30');

					for (let elm of elements) {
						let currentSize = window.getComputedStyle(elm).fontSize.replace("px", "")
						elm.style.fontSize = (parseInt(currentSize) - 6) + 'px'
					}

				}

				if (this.counter <= 0) {
					this.counter = 0;
					decreaseFont.classList.add('opacity-30');
					increaseFont.classList.remove('opacity-30');
				}
			},

			increaseFont() {
				let elements = textToSpeachElm.querySelectorAll('p, h2, h3, li, a');
				this.counter++

				let decreaseFont = document.querySelector('.decrease-font');
				let increaseFont = document.querySelector('.increase-font');

				if (this.counter >= 1 && this.counter <= 2) {
					decreaseFont.classList.remove('opacity-30');
					for (let elm of elements) {
						let currentSize = window.getComputedStyle(elm).fontSize.replace("px", "")
						elm.style.fontSize = (parseInt(currentSize) + 6) + 'px'
					}
				}

				if (this.counter >= 2) {
					this.counter = 2;
					increaseFont.classList.add('opacity-30');
				}

			}
		}
	})

	Alpine.data('guideNav', function () {
		return {
			guideNav: this.$persist({ guide: null, articleKey: null, guides: null }),
			guideNavLoaded: this.$persist(false),

			activeGuide: this.$persist(''),
			seenArticles: this.$persist([]),

			setActiveGuide: function (guideKey) {
				this.activeGuide = guideKey;
				this.seenArticles = [];
				this.guideNav.guide = null;
				this.guideNav.guides = null;
			},
			setArticleSeen: function (articleKey) {
				if (this.seenArticles.indexOf(articleKey) < 0) {
					this.seenArticles.push(articleKey);
				}
			},
			getNav: function (articleKey) {
				if (this.activeGuide != '') {
					fetch('/umbraco/GuideNav/Navigation/Get?guideKey=' + this.activeGuide)
						.then(response => response.json())
						.then(data => {
							var articleIsInActiveGuide = false;
							for (let link of data.Links) {
								if (articleKey == link.Key) {
									this.guideNav.guide = data;
									this.$nextTick(() => this.guideNavLoaded = true);
									articleIsInActiveGuide = true;
								}
								else if (!articleIsInActiveGuide) {
									this.guideNav.guide = null;
									this.$nextTick(() => this.guideNavLoaded = false);
								}
							}
						});
				}
				else if (articleKey) {
					if (this.guideNav.articleKey != articleKey) {
						this.guideNav.articleKey = articleKey;
						this.guideNav.guides = null;
					}

					fetch('/umbraco/GuideNav/Navigation/GetGuidesByArticle?articleKey=' + articleKey)
						.then(response => response.json())
						.then(data => {
							this.guideNav.guides = data;
							this.$nextTick(() => this.guideNavLoaded = true);
						})
				}
			},
		}
	})
})

